// extracted by css-extract-rspack-plugin
export default {"UpsellPillComponent":"lZmV7"};